import script from "./DepositSectionProvisions.vue?vue&type=script&setup=true&lang=js"
export * from "./DepositSectionProvisions.vue?vue&type=script&setup=true&lang=js"

import "./DepositSectionProvisions.vue?vue&type=style&index=0&id=68b12e64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68b12e64"]])

export default __exports__